export default __webpack_public_path__ + "static/media/3148.eef7db07.jpg";